export default __webpack_public_path__ + "static/floating-cloud-nl-28b007794b39cfd0d23ece6cd1193e0d.png";